(() => {
  const selector = '.template-index [id$="slideshow_nHHE88"] .sslide[data-type="video"]';

  function activeVideo(slide) {
    return [...slide.querySelectorAll('video')].find(video => getComputedStyle(video).display !== 'none') || slide.querySelector('video');
  }

  function enhance(root = document) {
    const slides = root === document
      ? document.querySelectorAll(selector)
      : root.matches?.('.sslide[data-type="video"]')
        ? [root]
        : root.querySelectorAll('.sslide[data-type="video"]');
    slides.forEach(slide => {
      slide.style.setProperty('opacity', '1', 'important');
      slide.style.setProperty('visibility', 'visible', 'important');
      if (slide.querySelector('.nat-video-toggle') || !slide.querySelector('video')) return;

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'nat-video-toggle';
      button.setAttribute('aria-label', 'Pause video');
      button.setAttribute('aria-pressed', 'false');
      button.innerHTML = '<span class="nat-video-toggle__icon" aria-hidden="true"></span>';

      const sync = () => {
        const video = activeVideo(slide);
        const paused = !video || video.paused;
        button.setAttribute('aria-pressed', String(paused));
        button.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
      };

      button.addEventListener('click', () => {
        const video = activeVideo(slide);
        if (!video) return;
        if (video.paused) video.play().catch(() => {});
        else video.pause();
        sync();
      });

      slide.querySelectorAll('video').forEach(video => {
        video.addEventListener('play', sync);
        video.addEventListener('pause', sync);
        video.muted = true;
        video.defaultMuted = true;
        video.playsInline = true;
        if (getComputedStyle(video).display !== 'none') video.play().catch(() => {});
      });
      slide.appendChild(button);
      sync();
    });
  }

  enhance();
  document.addEventListener('shopify:section:load', event => enhance(event.target));
})();
